import React, { useState, useEffect, useRef, useCallback } from "react";
import parse, { domToReact } from "html-react-parser";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  FaBriefcase,
  FaSearch,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import DOMPurify from "dompurify";
import config from "../../../config/config";
import axios from "axios";
import { Button } from "antd";
import { useUser } from "../../../context/UserContext";

const WorkerMessageContent = ({ userId, myjobId, onBackToJobs }) => {
  const { fetchUserDetailsById, workerUser } = useUser();
  const [user, setUser] = useState(null);
  const [selectedId, setSelectedId] = useState(userId);
  const [text, setText] = useState("");
  const [chatInfoPane, setChatInfoPane] = useState(true);
  const [showContent, setShowContent] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isAgreementSigned, setIsAgreementSigned] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [localMessagesData, setLocalMessagesData] = useState([]);
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const [callsBlocked, setCallsBlocked] = useState(false);
  const [userBlocked, setUserBlocked] = useState(false);
  const [userReported, setUserReported] = useState(false);
  const [chatArchived, setChatArchived] = useState(false);

  const [shouldScrollToBottom, setShouldScrollToBottom] = useState(false);
  useState(false);

  const [selectedJobId, setSelectedJobId] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [selectedJobLocation, setSelectedJobLocation] = useState("");
  const [selectedJobDescription, setSelectedJobDescription] = useState("");
  const [client, setClient] = useState({});
  const [clientId, setClientId] = useState("");
  const [clientFirstName, setClientFirstName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [unreadCounts, setUnreadCounts] = useState({});
  const [newMessagesCount, setNewMessagesCount] = useState(0);
  const [lastMessageCount, setLastMessageCount] = useState(0);
  const [isStepModalVisible, setStepModalVisible] = useState(false);
  const [sessionName, setSessionName] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(4);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredMessagesData, setFilteredMessagesData] = useState([]);

  const [messageSearchTerm, setMessageSearchTerm] = useState("");
  const [highlightedMessages, setHighlightedMessages] = useState([]);

  const baseURL = config.API_BASE_URL;

  const navigate = useNavigate();
  const location = useLocation();

  const { messageId } = useParams();

  const [clientImageUrl, setClientImageUrl] = useState("/images/avatar.jpg");
  const [workerImageUrl, setWorkerImageUrl] = useState("/images/avatar.jpg");

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMessagesData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredMessagesData.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const firstPage = () => setCurrentPage(1);
  const prevPage = () => setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));
  const nextPage = () =>
    setCurrentPage((prev) => (prev < totalPages ? prev + 1 : prev));
  const lastPage = () => setCurrentPage(totalPages);
  const selectedUser = localMessagesData.find(
    (message) => message.id === selectedId
  );

  useEffect(() => {
    if (userId) {
      fetchUserDetailsById(userId, "worker");
      setUser(workerUser);
    }
  }, [userId, fetchUserDetailsById, workerUser]);

  useEffect(() => {
    if (selectedId) {
      sessionStorage.setItem("messageId", selectedId);
      console.log("Saved messageId to sessionStorage: ", selectedId);
    }
  }, [selectedId]);

  useEffect(() => {
    if (messageId && localMessagesData.length > 0) {
      handleItemClick(messageId);
    }
  }, [messageId, localMessagesData]);

  useEffect(() => {
    if (selectedUser && selectedUser.clientId && user && user.id) {
      fetchImage(selectedUser.clientId)
        .then((urls) => {
          setClientImageUrl(urls.clientImageUrl);
          setWorkerImageUrl(urls.workerImageUrl);
        })
        .catch((err) => console.error("Failed to fetch images:", err));
    }
  }, [selectedUser, user]);

  useEffect(() => {
    const filteredData = localMessagesData.filter(({ client }) =>
      client.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredMessagesData(filteredData);
  }, [searchTerm]);

  useEffect(() => {
    const filteredData = localMessagesData.filter(({ client }) =>
      client.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredMessagesData(filteredData);
  }, [localMessagesData]);

  const adjustMessageType = (message, currentUserRole) => {
    if (currentUserRole === message.sender) {
      return "outgoing";
    } else if (currentUserRole === message.receiver) {
      return "incoming";
    }
    console.error("Invalid user role or message structure detected.", {
      currentUserRole,
      message,
    });
    throw new Error("Invalid user role or message structure.");
  };

  const getCurrentUserRole = () => {
    return "worker";
  };

  const userType = getCurrentUserRole();

  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);

  useEffect(() => {
    console.log("User from FSInbox: ", user);
    if (selectedId && messagesContainerRef.current) {
      const firstUnreadMessage = messagesContainerRef.current.querySelector(
        ".new-message-indicator"
      );
      if (firstUnreadMessage) {
        const offsetTop = firstUnreadMessage.offsetTop;
        messagesContainerRef.current.scrollTop =
          offsetTop -
          messagesContainerRef.current.clientHeight / 2 +
          firstUnreadMessage.clientHeight / 2;
      }
    }
  }, [selectedId]);

  useEffect(() => {
    if (selectedId) {
      setNotificationsEnabled(true);
    } else {
      setNotificationsEnabled(false);
    }
  }, [selectedId]);

  useEffect(() => {
    if (location.state && location.state.selectedId) {
      setSelectedId(location.state.selectedId);
      setShowContent(true);
    }
  }, [location, location.state]);

  useEffect(() => {
    const storedJobTitle = sessionStorage.getItem("jobTitle");
    if (storedJobTitle) {
      setJobTitle(storedJobTitle);
    }
  }, []);

  useEffect(() => {
    const savedSessionName = sessionStorage.getItem("sessionName");
    const savedJobTitle = sessionStorage.getItem("jobTitle");
    const savedJobId = sessionStorage.getItem("jobId");
    const savedJobLocation = sessionStorage.getItem("jobLocation");
    const savedJobDescription = sessionStorage.getItem("jobDescription");
    const savedClientId = sessionStorage.getItem("clientId");
    const savedClientFirstName = sessionStorage.getItem("clientFirstName");
    const savedClientLastName = sessionStorage.getItem("clientLastName");
    const savedClientEmail = sessionStorage.getItem("clientEmail");

    console.log("Restored sessionName from sessionStorage:", savedSessionName);
    console.log("Restored jobTitle from sessionStorage:", savedJobTitle);
    console.log("Restored jobId from sessionStorage:", savedJobId);
    console.log("Restored jobLocation from sessionStorage:", savedJobLocation);
    console.log(
      "Restored jobDescription from sessionStorage:",
      savedJobDescription
    );
    console.log("Restored clientId from sessionStorage:", savedClientId);
    console.log(
      "Restored clientFirstName from sessionStorage:",
      savedClientFirstName
    );
    console.log(
      "Restored clientLastName from sessionStorage:",
      savedClientLastName
    );

    console.log("Restored clientEmail from sessionStorage:", savedClientEmail);

    if (savedSessionName) {
      setSessionName(savedSessionName);
    }
    if (savedJobTitle) {
      setJobTitle(savedJobTitle);
    }
    if (savedJobId) {
      setSelectedJobId(savedJobId);
    }
    if (savedJobLocation) {
      setSelectedJobLocation(savedJobLocation);
    }
    if (savedJobDescription) {
      setSelectedJobDescription(savedJobDescription);
    }
  }, []);

  useEffect(() => {
    if (shouldScrollToBottom && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      setShouldScrollToBottom(false);
    } else if (highlightedMessages.length > 0) {
      const highlightedElement = document.querySelector(".highlighted-message");
      if (highlightedElement) {
        const scrollContainer = messagesContainerRef.current;
        const scrollOffset = scrollContainer.scrollHeight * 0.25;
        scrollContainer.scrollTop = highlightedElement.offsetTop - scrollOffset;
      }
    }
  }, [shouldScrollToBottom, highlightedMessages]);

  const fetchMessages = useCallback(async () => {
    try {
      const response = await axios.get(`${baseURL}/v1/messages`);
      const relevantMessages = response.data.filter((message) => {
        const isSender = message.workerId === userId;
        const isReceiver = message.clientId === userId;
        return isSender || isReceiver;
      });

      const sortedMessages = relevantMessages.sort((a, b) => {
        const aLatestTimestamp = a.fullMessages.reduce((latest, msg) => {
          return new Date(msg.timestamp).getTime() > latest
            ? new Date(msg.timestamp).getTime()
            : latest;
        }, 0);
        const bLatestTimestamp = b.fullMessages.reduce((latest, msg) => {
          return new Date(msg.timestamp).getTime() > latest
            ? new Date(msg.timestamp).getTime()
            : latest;
        }, 0);
        return bLatestTimestamp - aLatestTimestamp;
      });

      let totalNewMessages = 0;
      const newUnreadCounts = {};
      sortedMessages.forEach((message) => {
        let unreadCount = 0;
        message.fullMessages.forEach((fullMessage) => {
          if (!fullMessage.read && fullMessage.receiver === userType) {
            unreadCount++;
            totalNewMessages++;
          }
        });
        if (unreadCount > 0) {
          newUnreadCounts[message.id] = unreadCount;
        }
      });

      if (totalNewMessages > lastMessageCount) {
      }

      setLastMessageCount(totalNewMessages);
      setUnreadCounts(newUnreadCounts);
      setLocalMessagesData(sortedMessages);
      setNewMessagesCount(totalNewMessages);
    } catch (error) {
      console.error("Error fetching messages data:", error);
    }
  }, [baseURL, userId, userType, lastMessageCount]);

  useEffect(() => {
    const fetchAndSetJobTitle = async (jobId) => {
      try {
        const jobResponse = await axios.get(`${baseURL}/v1/jobs/${jobId}`);
        const jobData = jobResponse.data;
        if (
          jobData &&
          jobData.jobcraftDetails &&
          jobData.jobcraftDetails.jobTitle
        ) {
          setJobTitle(jobData.jobcraftDetails.jobTitle);
          setSelectedJobId(jobId);
        } else {
          console.error("Job details fetched but job title is missing.");
        }
      } catch (error) {
        console.error("Failed to fetch job details:", error);
      }
    };

    const selectedMessage = localMessagesData.find(
      (message) => message.id === selectedId
    );
    if (selectedMessage) {
      const jobId = selectedMessage.fullMessages[0]?.jobId;
      if (jobId) {
        fetchAndSetJobTitle(jobId);
      }
    }
  }, [selectedId, localMessagesData, baseURL]);

  useEffect(() => {
    fetchMessages();
    const intervalId = setInterval(fetchMessages, 1000);
    return () => clearInterval(intervalId);
  }, [fetchMessages]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && showContent) {
        setChatInfoPane(true);
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [showContent]);

  useEffect(() => {
    if (shouldScrollToBottom && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      setShouldScrollToBottom(false);
    }
  }, [shouldScrollToBottom]);

  const fetchImage = async (clientId) => {
    let workerImageUrl = "/images/avatar.jpg";
    let clientImageUrl = "/images/avatar.jpg";

    if (clientId) {
      try {
        const clientResponse = await axios.get(
          `${baseURL}/v1/client-users/${clientId}`
        );
        const clientUserData = clientResponse.data;
        if (clientUserData && clientUserData.profilePhoto) {
          clientImageUrl = `${baseURL}/v1/${clientUserData.userType}-users/profile-images/${clientUserData.profilePhoto}`;
        }
      } catch (error) {}
    }

    if (user && user.profilePhoto) {
      try {
        workerImageUrl = `${baseURL}/v1/${user.userType}-users/profile-images/${user.profilePhoto}`;
      } catch (error) {}
    }

    return { clientImageUrl, workerImageUrl };
  };

  const handleItemClick = async (id) => {
    console.log("HandleItem clicked for messageId", id);
    setSelectedId(id);
    setShowContent(true);
    const selectedUser = localMessagesData.find((message) => message.id === id);
    if (selectedUser) {
      console.log("Selected Message :", selectedUser);
      setClientId(selectedUser.clientId);
      console.log("Selected Client Id :", selectedUser.clientId);
      setClientId(selectedUser.clientId);
      console.log("Only client Id", clientId);
      setIsAgreementSigned(selectedUser.agreementSigned);
      setSessionName(selectedUser.meetAndGreetSessionName);
      sessionStorage.setItem(
        "sessionName",
        selectedUser.meetAndGreetSessionName
      );
      if (
        selectedUser.fullMessages &&
        selectedUser.fullMessages.length > 0 &&
        selectedUser.fullMessages[0].jobId
      ) {
        const jobId = selectedUser.fullMessages[0].jobId;
        try {
          const response = await fetch(`${baseURL}/v1/jobs/${jobId}`);
          const jobData = await response.json();
          console.log("Job WIth Title : ", jobData);
          const selectedJobId = jobData.id;
          const jobLocation = jobData.suburbValue;
          const jobTitle = jobData.jobcraftDetails.jobTitle;
          const jobDescription = jobData.jobcraftDetails.jobDescription;
          if (jobData && jobTitle && selectedJobId) {
            setSelectedJobId(selectedJobId);
            setSelectedJobLocation(jobLocation);
            setJobTitle(jobTitle);
            setSelectedJobDescription(jobDescription);
            console.log("Job WIth ID and Title : ", selectedJobId, jobTitle);
            sessionStorage.setItem("jobId", jobData.id);
            sessionStorage.setItem(
              "jobTitle",
              jobData.jobcraftDetails.jobTitle
            );
            sessionStorage.setItem("jobLocation", jobData.suburbValue);
            sessionStorage.setItem(
              "jobDescription",
              jobData.jobcraftDetails.jobDescription
            );
            if (jobData.clientId) {
              try {
                const clientResponse = await axios.get(
                  `${baseURL}/v1/client-users/${jobData.clientId}`
                );
                const clientData = clientResponse.data;
                setClient(clientData);
                setClientFirstName(clientData.firstName);
                setClientEmail(clientData.email);
                sessionStorage.setItem("clientId", clientData.id);
                sessionStorage.setItem("clientFirstName", clientData.firstName);
                sessionStorage.setItem("clientLastName", clientData.lastName);
                sessionStorage.setItem("clientEmail", clientData.email);
                console.log("Fetched client details:", clientData);
                console.log("Fetched client First Name:", clientData.firstName);
                console.log("Fetched client Email:", clientData.email);
              } catch (error) {
                console.error("Error fetching client details:", error);
              }
            }
          }
        } catch (error) {
          console.error("Error fetching job details:", error);
        }
      }
    }

    await fetchImage(selectedUser.clientId);

    await new Promise((resolve) => setTimeout(resolve, 0));

    const messagesContainer = document.querySelector(".messages");
    if (messagesContainer) {
      const firstUnreadMessageElement = messagesContainer.querySelector(
        ".new-message-indicator"
      );
      if (firstUnreadMessageElement) {
        const offsetTop = firstUnreadMessageElement.offsetTop;
        const scrollTarget =
          offsetTop -
          messagesContainer.offsetHeight / 2 +
          firstUnreadMessageElement.offsetHeight / 2;
        messagesContainer.scrollTop = scrollTarget;
      }
    }

    if (window.innerWidth > 768) {
      setChatInfoPane(true);
    }
  };

  const renderMessageStatus = (message) => {
    const currentUserRole = getCurrentUserRole();

    if (message.sender === currentUserRole) {
      const statusClass = message.read
        ? "message-status-read"
        : "message-status-unread";
      return (
        <span className={`message-status ${statusClass}`}>
          {message.read ? "🗸🗸" : "🗸"}
        </span>
      );
    }
    return null;
  };

  const cleanLatestTextMessage = (htmlString) => {
    htmlString = htmlString.replace(/<(script|style).*?>.*?<\/\1>/gi, "");
    const textArea = document.createElement("textarea");
    textArea.innerHTML = htmlString;
    htmlString = textArea.value;
    htmlString = htmlString.replace(/<[^>]*>/g, "");
    htmlString = htmlString.replace(/\s+/g, " ");
    htmlString = htmlString.trim();
    return htmlString.substring(0, 30);
  };

  const sanitizeAndParseHtml = (htmlString) => {
    const cleanHtml = DOMPurify.sanitize(htmlString, {
      ADD_TAGS: ["a"],
      ADD_ATTR: ["href", "target", "title"],
    });

    const options = {
      replace: ({ attribs, children, name }) => {
        if (name === "a") {
          return (
            <a
              href={attribs.href}
              target={attribs.target || "_blank"}
              title={attribs.title}
              className="sanitized-message-text"
            >
              {domToReact(children, options)}
            </a>
          );
        } else if (["p", "span", "div"].includes(name)) {
          return <span {...attribs}>{domToReact(children, options)}</span>;
        }
      },
    };

    return parse(cleanHtml, options);
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatMessageDate = (timestamp) => {
    const date = new Date(timestamp);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const truncateJobTitle = (str, maxLength) => {
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + "...";
    } else {
      return str;
    }
  };

  const handleJobTitleClick = (job) => {
    const url = `/account/admin-dashboard/jobs/${selectedJobId}`;
    window.open(url, "_blank");
  };

  const cleanJobDescription = (htmlString) => {
    htmlString = htmlString.replace(/<(script|style).*?>.*?<\/\1>/gi, "");

    const entitiesMap = {
      "&nbsp;": " ",
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'",
    };

    htmlString = htmlString.replace(/&[a-zA-Z0-9#]+;/g, (entity) => {
      return entitiesMap[entity] || entity;
    });

    htmlString = htmlString
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    return htmlString;
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleMessageSearchChange = (e) => {
    const term = e.target.value;
    setMessageSearchTerm(term);

    if (term === "") {
      setHighlightedMessages([]);
      return;
    }

    const highlighted = selectedUser.fullMessages
      .map((msg, index) => {
        if (msg.text.toLowerCase().includes(term.toLowerCase())) {
          return index;
        }
        return null;
      })
      .filter((index) => index !== null);

    setHighlightedMessages(highlighted);
  };

  return (
    <div className="worker-messages-container-admin">
      <div className="worker-messages-left-admin">
        <div className="wm-left-top-admin">
          <div className="message-list-content-div">
            <div className="wmsgsml-search-input-container">
              <input
                type="text"
                placeholder="Search client .."
                className="wmsgs-search-input"
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <FaSearch className="wmsgs-search-icon" />
            </div>
            <ul>
              {currentItems.map(({ id, client, fullMessages }) => {
                const latestMessage =
                  fullMessages[fullMessages.length - 1]?.text || "";
                const cleanedLatestMessage =
                  cleanLatestTextMessage(latestMessage);
                const unreadCount = unreadCounts[id] || 0;
                const latestMessageTimestamp =
                  fullMessages[fullMessages.length - 1]?.timestamp || "";

                return (
                  <li
                    key={id}
                    onClick={() => handleItemClick(id)}
                    className={
                      id === selectedId ? "inbox-selected-message" : ""
                    }
                  >
                    <div className="thumbnail">{client[0]}</div>
                    <div className="info">
                      <div className="user">
                        <h3>
                          {client.split(" ").map((name, index, array) => {
                            if (index === 0) {
                              return name;
                            } else if (index === array.length - 1) {
                              return " " + name.charAt(0) + ".";
                            }
                            return null;
                          })}
                        </h3>
                        {unreadCount > 0 && (
                          <span className="unread-count">{unreadCount}</span>
                        )}
                        <span className="last-message-date">
                          {formatMessageDate(latestMessageTimestamp)}
                        </span>
                      </div>
                      <div className="latest-message">
                        {cleanedLatestMessage + "..."}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="wm-list-pagination">
            <button onClick={firstPage} disabled={currentPage === 1}>
              &laquo;
            </button>
            <button onClick={prevPage} disabled={currentPage === 1}>
              &lt;
            </button>
            <span>
              Page <strong>{currentPage}</strong> of{" "}
              <strong>{totalPages}</strong>
            </span>
            <button onClick={nextPage} disabled={currentPage === totalPages}>
              &gt;
            </button>
            <button onClick={lastPage} disabled={currentPage === totalPages}>
              &raquo;
            </button>
          </div>
        </div>
        {selectedUser && (
          <div className="wm-left-bottom-admin">
            <div className="chat-actions">
              <div className="action-grid">
                <div className="action-item">
                  <span>Alerts </span>
                  <span className="wm-chat-icon">
                    {notificationsEnabled ? (
                      <FaCheckCircle className="wm-chat-icon-enabled" />
                    ) : (
                      <FaTimesCircle className="wm-chat-icon-disabled" />
                    )}
                  </span>
                </div>
                <div className="action-item">
                  <span>Calls blocked?</span>
                  <span className="wm-chat-icon">
                    {callsBlocked ? (
                      <FaCheckCircle className="wm-chat-icon-enabled" />
                    ) : (
                      <FaTimesCircle className="wm-chat-icon-disabled" />
                    )}
                  </span>
                </div>
                <div className="action-item">
                  <span>User blocked?</span>
                  <span className="wm-chat-icon">
                    {userBlocked ? (
                      <FaCheckCircle className="wm-chat-icon-enabled" />
                    ) : (
                      <FaTimesCircle className="wm-chat-icon-disabled" />
                    )}
                  </span>
                </div>
                <div className="action-item">
                  <span>User reported?</span>
                  <span className="wm-chat-icon">
                    {userReported ? (
                      <FaCheckCircle className="wm-chat-icon-enabled" />
                    ) : (
                      <FaTimesCircle className="wm-chat-icon-disabled" />
                    )}
                  </span>
                </div>
                <div className="action-item">
                  <span>Chat archived?</span>
                  <span className="wm-chat-icon">
                    {chatArchived ? (
                      <FaCheckCircle className="wm-chat-icon-enabled" />
                    ) : (
                      <FaTimesCircle className="wm-chat-icon-disabled" />
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="worker-messages-right-admin">
        {selectedUser && (
          <div className="wm-contentHeader">
            <div className="wmsgs-search-input-container">
              <input
                type="text"
                placeholder="Search messages"
                className="wmsgs-search-input"
                value={messageSearchTerm}
                onChange={handleMessageSearchChange}
              />
              <FaSearch className="wmsgs-search-icon" />
            </div>
            <div className="wm-client-job-container">
              <span className="inbox-message-header">
                {selectedUser.client.split(" ")[0]}
              </span>
              <div className="job-inbox-title">
                <span className="job-fa-icon">
                  <FaBriefcase />
                </span>
                <span className="job-title-text" onClick={handleJobTitleClick}>
                  {truncateJobTitle(jobTitle, 65)}
                </span>
              </div>
            </div>
          </div>
        )}
        {selectedId && (
          <>
            <div className="wm-chat-messages-scroll-wrapper">
              <div
                className="wm-inbox-chat-messages"
                ref={messagesContainerRef}
              >
                {selectedUser &&
                  selectedUser.fullMessages.map((msg, index, array) => {
                    const isFirstUnread =
                      index ===
                      array.findIndex(
                        (m) => !m.read && m.receiver === userType
                      );
                    const currentMessageDate = new Date(
                      msg.timestamp
                    ).toDateString();
                    const previousMessageDate =
                      index > 0
                        ? new Date(array[index - 1].timestamp).toDateString()
                        : null;

                    const highlight = highlightedMessages.includes(index);

                    const sanitizedMessageText = sanitizeAndParseHtml(msg.text);
                    const highlightedText = highlight
                      ? React.Children.map(sanitizedMessageText, (node) => {
                          if (typeof node === "string") {
                            const parts = node.split(
                              new RegExp(`(${messageSearchTerm})`, "gi")
                            );
                            return parts.map((part, j) =>
                              part.toLowerCase() ===
                              messageSearchTerm.toLowerCase() ? (
                                <span
                                  key={j}
                                  className="highlighted-message-text"
                                >
                                  {part}
                                </span>
                              ) : (
                                part
                              )
                            );
                          }
                          return node;
                        })
                      : sanitizedMessageText;

                    const highlightedRef = highlight ? messagesEndRef : null;

                    return (
                      <React.Fragment key={index}>
                        {(index === 0 ||
                          currentMessageDate !== previousMessageDate) && (
                          <div className="date-header">
                            <hr className="date-divider" style={{ left: 0 }} />
                            <span className="date-text">
                              {formatDate(msg.timestamp)}
                            </span>
                            <hr className="date-divider" style={{ right: 0 }} />
                          </div>
                        )}
                        {isFirstUnread && unreadCounts[selectedId] > 0 && (
                          <div className="new-message-indicator">
                            {unreadCounts[selectedId]} New Message
                            {unreadCounts[selectedId] > 1 ? "s" : ""}
                          </div>
                        )}
                        {selectedUser && (
                          <div className="avatar-container">
                            {adjustMessageType(msg, userType) ===
                              "incoming" && (
                              <div className="message-sender">
                                <img
                                  src={clientImageUrl}
                                  alt="User Avatar"
                                  className="avatar-outgoing"
                                />
                                <span>{selectedUser.client}</span>
                              </div>
                            )}

                            {adjustMessageType(msg, userType) ===
                              "outgoing" && (
                              <div className="message-receiver">
                                <span>
                                  {user.firstName} {user.lastName}
                                </span>
                                <img
                                  src={workerImageUrl}
                                  alt="User Avatar"
                                  className="avatar-outgoing"
                                />
                              </div>
                            )}
                          </div>
                        )}
                        <div
                          className={`message-item ${adjustMessageType(
                            msg,
                            userType
                          )} ${highlight ? "highlighted-message" : ""}`}
                          ref={highlightedRef}
                        >
                          <div className="message-wrapper">
                            <div className="message-text-wrapper">
                              <span className="message-text">
                                {highlightedText}
                              </span>
                            </div>
                          </div>
                          <div className="message-time-wrapper">
                            <span
                              className={`message-time ${adjustMessageType(
                                msg,
                                userType
                              )}-time`}
                            >
                              {formatTime(msg.timestamp)}
                              {renderMessageStatus(msg)}
                            </span>
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                <div ref={messagesEndRef} />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default WorkerMessageContent;
